import { render, staticRenderFns } from "./contracts.vue?vue&type=template&id=2863322c"
import script from "./contracts.vue?vue&type=script&lang=js"
export * from "./contracts.vue?vue&type=script&lang=js"
import style0 from "./contracts.vue?vue&type=style&index=0&id=2863322c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports